import { Link } from 'react-router-dom';

const HowItWorks = () => {
  const steps = [
    {
      title: 'Browse or Sign Up',
      description: 'Create your free account and explore thousands of listings from fellow students',
      icon: 'ri-search-line',
      color: 'bg-blue-500'
    },
    {
      title: 'Find Verified Matches',
      description: 'Compare listings, check seller ratings, and find the best deals near you',
      icon: 'ri-shield-check-line',
      color: 'bg-green-500'
    },
    {
      title: 'Connect Safely',
      description: 'Message verified sellers and meet at recommended safe campus locations',
      icon: 'ri-message-line',
      color: 'bg-purple-500'
    },
    {
      title: 'Complete Transaction',
      description: 'Buy with confidence knowing every seller on Campus Market is verified',
      icon: 'ri-check-line',
      color: 'bg-teal-500'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            How Campus Market Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Four simple steps to smart, safe campus trading with fellow students
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gray-200 z-0">
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-2 h-2 bg-gray-300 rounded-full"></div>
                </div>
              )}
              
              <div className="relative bg-white rounded-xl p-6 text-center border border-gray-100 hover:shadow-lg transition-all duration-300 z-10">
                <div className="relative mb-6">
                  <div className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                    <i className={`${step.icon} text-white text-2xl`}></i>
                  </div>
                </div>
                
                <h3 className="font-semibold text-gray-900 mb-3">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 text-sm">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/marketplace"
            className="inline-flex items-center px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-line mr-2"></i>
            Browse the Marketplace
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;